import { render } from "./AllergiesListDialog.vue?vue&type=template&id=644526c7&scoped=true"
import script from "./AllergiesListDialog.vue?vue&type=script&lang=js"
export * from "./AllergiesListDialog.vue?vue&type=script&lang=js"

import "./AllergiesListDialog.vue?vue&type=style&index=0&id=644526c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644526c7"]])

export default __exports__